import React from "react";
import {
  BrowserRouter as Router,
  Link,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import { createBrowserHistory } from "history";
import "./scss/global.scss";
import Loading from "./components/Loading/Loading";

const Home = React.lazy(() => import("./pages/Home/Home"));
const Guideline = React.lazy(() => import("./pages/Activities/Guideline"));
// const CallObjective = React.lazy(() =>
//   import("./pages/Activities/CallObjective")
// );
const Brand = React.lazy(() => import("./pages/Brand/Brand"));
const Error404 = React.lazy(() => import("./pages/404"));
const AuthLoading = React.lazy(() => import("./pages/Home/AuthLoading"));
const historyInstance = createBrowserHistory();

const App = () => (
  <Router history={historyInstance}>
    <React.Suspense fallback={<Loading />}>
      <Switch>
        <Route exact path="/Home" component={Home} />
        <Route exact path="/auth" component={AuthLoading} />
        <Route
          exact
          path="/Activities/Guideline & Working Outline"
          component={Guideline}
        />
        {/* <Route exact path="/Activities/Call Objectives" component={CallObjective} /> */}
        <Redirect from="/Activities/Call Objectives" to="/Home" />
        <Route path="/Brand" component={Brand} />
        <Route path="/404" component={Error404} />
        <Route path="/" component={Home} />
      </Switch>
    </React.Suspense>
  </Router>
);

export default App;
